import { Box, Typography } from "@mui/material";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const SlackSaaSNHIDetailsView = ({ entityData }) => {
  const slackData = entityData?.slack_saas_nhi_data || {};

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {slackData.bot_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Bot Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={slackData.bot_name} />
          </Box>
        </Box>
      )}
      {slackData.app_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>App Name</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={slackData.app_name} />
          </Box>
        </Box>
      )}
      {slackData.team_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Workspace</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle title={""} value={slackData.team_name} />
          </Box>
        </Box>
      )}
      {slackData.is_admin !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Admin</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={slackData.is_admin ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SlackSaaSNHIDetailsView;
